<template>
  <page-view title="专家标签管理">
    <template slot="action">
      <a-space>
        <a-popconfirm title="该设置的方式会覆盖已设置的标签！，请谨慎操作" ok-text="确认" cancel-text="取消"
                      @confirm="batchSetTag">
          <a-button v-if="isAdmin" icon="book" type="primary">一键设置</a-button>
        </a-popconfirm>
        <a-popconfirm title="是否确认要重置已选的专家标签！" ok-text="确认" cancel-text="取消" @confirm="batchRestTag">
          <a-button v-if="isAdmin" :loading="restLoading" icon="logout" type="primary">一键重置
          </a-button>
        </a-popconfirm>
      </a-space>
    </template>
    <a-card class="mb-3">
      <a-form-model class="exi_form v2"
                    ref="form" :label-col="{ flex: '0 0 auto' }" :wrapper-col="{ span: 24 }">
        <a-form-model-item label="采购品目名称|编码" style="width: 600px">
          <a-input v-model="form.purchaseItem" placeholder="采购品目名称|编码"/>
        </a-form-model-item>
        <a-form-model-item label="专家名称" prop="expertName" style="width: 400px">
          <a-input v-model="form.expertName" placeholder="专家名称"/>
        </a-form-model-item>
        <a-form-model-item label="标签名称" prop="tagName" style="width: 400px">
          <a-input v-model="form.tagName" placeholder="标签名称"/>
        </a-form-model-item>
        <a-button type="primary" @click="onSearch">查询</a-button>
        <a-button @click="reset">重置</a-button>
      </a-form-model>
    </a-card>
    <a-card>
      <s-table
          ref="table"
          :columns="columns"
          :data="loadData"
          :rowKey="record => record.expertId"
          :pagination="{ showTotal: (total) => `共 ${total} 条` }"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
      >
        <template v-slot:tag="record">
          <a-tag
              v-for="(it, index) in record.tagInfoList"
              :key="it.id"
              :title="it.tagDetail"
              :color="it.tagColor">
            {{ it.tagName }}
          </a-tag>
        </template>
        <template v-slot:option="record">
          <a-space>
            <a class="link_blue" type="primary" @click="doSet(record.expertId, record.tagIds)">设置</a>
            <a-divider type="vertical"/>
            <a-popconfirm title="确认重置所有标签?" ok-text="是" cancel-text="否" @confirm="onDelete(record.expertId)">
              <a class="link_blue">重置</a>
            </a-popconfirm>
          </a-space>
        </template>
      </s-table>
    </a-card>
    <tag-set-modal ref="tagSetModal" @success="onSetSuccess"/>
  </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import qs from 'qs'
import STable from '@comp/Table'
import TagSetModal from '@/epp/expertmain/experttag/modal/TagSetModal'

export default {
  name: 'ExpertTagIndex',
  components: {
    TagSetModal,
    PageView,
    STable,
  },
  created () {
  },
  computed: {
    isAdmin () {
      return (this.user.permissions['system.manage'])
    }
  },
  data () {
    return {
      form: {},
      selectedRowKeys: [],
      restLoading: false,
      user: this.$ls.get('user'),
      columns: [
        { title: '专家名称', align: 'left', dataIndex: 'expertName', width: '10%' },
        { title: '性别', align: 'left', dataIndex: 'genderText', width: '7%' },
        { title: '年龄', align: 'left', dataIndex: 'expertAge', width: '8%' },
        { title: '职称', align: 'left', dataIndex: 'professionalTitle', width: '15%' },
        { title: '所属品目', align: 'left', dataIndex: 'purchaseItem', ellipsis: true, width: '25%' },
        { title: '标签', align: 'left', scopedSlots: { customRender: 'tag' }, ellipsis: true, width: '25%' },
        { title: '标签管理', key: 'option', align: 'center', scopedSlots: { customRender: 'option' }, width: '10%' }
      ],
      loadData: parameter => {
        const data = { ...this.form }
        return this.$http.get('/api/1/expertmain/expert_tag/queryExpertTag', {
          params: Object.assign(parameter, data),
          paramsSerializer: function (params) {
            return qs.stringify(params, { indices: false })
          }
        }).then(res => {
          return res
        })
      }
    }
  },
  methods: {
    reset () {
      this.form = {}
      this.selectedRowKeys = []
      this.onSearch(true)
    },
    onSearch (bool = false) {
      this.$refs.table.refresh(bool)
    },

    doSet (expertId, ids) {
      this.$refs.tagSetModal.onStartLoadData(expertId, ids)
    },
    onSetSuccess () {
      this.onSearch()
    },
    onDelete (id) {
      this.restTag(id)
    },
    onSelectChange (selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    batchSetTag () {
      if (this.selectedRowKeys.length === 0) {
        this.$message.error('请选择需要设置标签的专家！')
        return
      }
      var expertId = this.selectedRowKeys.join(',')
      this.$refs.tagSetModal.onStartLoadData(expertId)
    },
    batchRestTag () {
      if (this.selectedRowKeys.length === 0) {
        this.$message.error('请选择需要重置标签的专家！')
        return
      }
      var expertId = this.selectedRowKeys.join(',')
      this.restTag(expertId)
    },
    //重置标签
    restTag (id) {
      this.$http.post('/api/1/expertmain/expert_tag/delTagExpert', qs.stringify({ expertId: id })).then(resp => {
        this.delLoading = false
        if (resp.code !== 200) {
          this.$error({ content: '重置失败！' })
          return false
        }
        this.$message.success('重置成功')
        this.$refs.table.refresh()
      })
    }
  }
}
</script>

<style scoped>

</style>
